import { render } from "./NetworkError.vue?vue&type=template&id=6723806e"
const script = {}
script.render = render

export default script